import { AxiosInstance } from "axios";
import { IError, ErrorTypes, IAuth } from "../../../interface/IShareInfo";
import { Dispatch } from "redux";
import { errorResponseHandler } from "../../../commons/utils/errorMessagesHandler";

export enum AuthActionTypes {
  AUTHENTICATE__PENDING = "AUTHENTICATE__PENDING",
  AUTHENTICATE__SUCCESS = "AUTHENTICATE__SUCCESS",
  AUTHENTICATE__FAILED = "AUTHENTICATE__FAILED",
  SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS"
}

const api_base = "";

export interface ISignInSuccess {
  type: AuthActionTypes.AUTHENTICATE__SUCCESS;
  payload: IAuth;
}

export interface ISignInFailed {
  type: AuthActionTypes.AUTHENTICATE__FAILED;
  error: IError;
}

export interface ISignInPending {
  type: AuthActionTypes.AUTHENTICATE__PENDING;
}

export interface ISignOutSuccess {
  type: AuthActionTypes.SIGN_OUT_SUCCESS;
}

export const signIn = (email: string, password: string) => async (
  dispatch: Dispatch,
  getState: any,
  axios: AxiosInstance
) => {
  dispatch<ISignInPending>({
    type: AuthActionTypes.AUTHENTICATE__PENDING
  });
  try {
    const response = await axios.post(`${api_base}/signIn/jwt`, {
      Username: email,
      Password: password
    });
    const { token_type, access_token } = response.data;
    const newToken = `${token_type} ${access_token}`;
    axios.defaults.headers.common["Authorization"] = newToken;

    dispatch<ISignInSuccess>({
      type: AuthActionTypes.AUTHENTICATE__SUCCESS,
      payload: {
        uid: undefined,
        role: undefined,
        token: newToken
      }
    });
  } catch (error) {
    const errorMessage = {
      type: ErrorTypes.AUTHENTICATION_ERROR,
      message: "Incorrect Username or Password."
    };

    dispatch<ISignInFailed>({
      type: AuthActionTypes.AUTHENTICATE__FAILED,
      error: errorResponseHandler(error, errorMessage) as IError
    });
    axios.defaults.headers.common["Authorization"] = "";
  }
};

export const signOut = () => (
  dispatch: Dispatch,
  getState: any,
  axios: AxiosInstance
) => {
  axios.defaults.headers.common["Authorization"] = "";
  dispatch<ISignOutSuccess>({
    type: AuthActionTypes.SIGN_OUT_SUCCESS
  });
};

export type AuthActions =
  | ISignInSuccess
  | ISignInPending
  | ISignInFailed
  | ISignOutSuccess;
